import { init as initLocales } from './locale';

initLocales();
